import { type NavigateFunction } from 'react-router-dom';
import { PAGES } from './constants';
import { useStaffSessionStore } from './store';

export const LOGOUT_REDIRECT_DELAY = 1000;

export function deferStaffLogout() {
    useStaffSessionStore.getState().setLogoutPending(true);
}

export function logoutCurrentStaff(
    navigate?: NavigateFunction,
    shouldDelayRedirect = false,
) {
    useStaffSessionStore.getState().reset();

    setTimeout(
        () => {
            navigate?.(PAGES.ONBOARDING.STAFF_LOGIN);
        },
        shouldDelayRedirect ? LOGOUT_REDIRECT_DELAY : 0,
    );
}
